import { Popup } from 'semantic-ui-react';
import { generatePath, Link, useLocation } from 'react-router';
import { Button, Icon } from '@britishcouncil/react-admin';
import { ROUTING_PATHS } from 'const';
import { useIntParam, useLrwSessionAllowedActions } from 'hooks';

export const LinkSessionButton = () => {
  const { linkSpeakingSession } = ROUTING_PATHS;
  const lrwSessionId = useIntParam('sessionId');
  const location = useLocation();
  const { canLinkSpeakingSession, cantLinkSpeakingSessionReasons } = useLrwSessionAllowedActions();
  const cannotLinkSpeakingSessionPlaceholder = cantLinkSpeakingSessionReasons.length ? (
    <Popup
      trigger={
        <span>
          <Button primary compact disabled>
            <Icon name="chain" />
            Link session
          </Button>
        </span>
      }
      content={cantLinkSpeakingSessionReasons.join(' ')}
      inverted
      position="left center"
    />
  ) : null;

  return canLinkSpeakingSession ? (
    <Link
      to={generatePath(linkSpeakingSession.absolutePath, { sessionId: lrwSessionId })}
      state={location.state}
    >
      <Button primary compact>
        <Icon name="chain" />
        Link session
      </Button>
    </Link>
  ) : (
    cannotLinkSpeakingSessionPlaceholder
  );
};
